// Generated with util/create-component.js
import Typography from './Base';

export default Typography;
